import React from "react";
import moment from "moment";
import { isTrue } from "../../../../../../../Utils/filter";
import {
    DiscussListItem,
    getDurationSeconds
} from "../../../../../../../API/discuss";

interface TimeLimitProps {
    data: DiscussListItem;
}

export default function TimeLimit({ data }: TimeLimitProps) {
    const { topicDurationDay, topicDurationHour, topicDurationMinute } = data;

    const seconds = getDurationSeconds({
        topicDurationDay,
        topicDurationHour,
        topicDurationMinute
    });

    if (isTrue(data.isStart) && moment(data.deadline).isBefore()) {
        return <span>已截止</span>;
    }
    if (!seconds) return <span>不限时</span>;

    if (isTrue(data.isStart) && moment(data.deadline).isAfter()) {
        return (
            <span
                title={`即将于${moment(data.deadline).format(
                    "YYYY-MM-DD HH:mm:ss"
                )}截止`}>
                剩余:&nbsp;
                <em>
                    {moment
                        .duration(moment(data.deadline).diff(moment()))
                        .humanize()}
                </em>
            </span>
        );
    }

    return (
        <span>
            限时:&nbsp;
            {!!topicDurationDay && <em>{topicDurationDay}天</em>}
            {!!topicDurationHour && <em>{topicDurationHour}小时</em>}
            {!!topicDurationMinute && <em>{topicDurationMinute}分钟</em>}
        </span>
    );
}
